import React from 'react'
import { Heading, Text } from '../ui'

type CentralAmparoPageHeaderProps = {
  title: string
  description?: string | null
  actions?: React.ReactNode
}

export const CentralAmparoPageHeader: React.FC<CentralAmparoPageHeaderProps> = ({
  title,
  description,
  actions,
}) => {
  return (
    <div className="flex items-center gap-4 min-w-0">
      <img
        src="/Logo_Central_de_Amparo.png"
        alt="Central de Amparo"
        className="h-14 w-auto flex-shrink-0 object-contain select-none"
      />
      <div className="min-w-0 flex-1">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
              {title}
            </Heading>
            {description ? (
              <Text size="sm" color="muted" className="mt-1">
                {description}
              </Text>
            ) : null}
          </div>
          {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
      </div>
    </div>
  )
}
